import React from 'react';
import VariantItem from '../variant-item/VariantItem';
import './VariantMappingPanel.scss';
import withPopover from '../../../HOCs/withPopover';
import VariantFilterPopover from './VariantFilterPopover';
import {ReactComponent as SortIcon} from '../../../assets/icons/linear-sort.svg';

const VariantMappingPanel = ({ 
  variants, 
  selectedVariantId,
  mappedCount,
  totalCount,
  onVariantSelect,
  onFilterClick,
  variantFilter,
  selectedFilters
}) => {
  const FilterButton = ({isOpen, ...rest}) => (
    <button className="filter-button" {...rest}>
      <SortIcon />
      Filter
    </button>
  )
  const FilterPopover = withPopover(FilterButton)
  return (
    <div className="right-panel">
      <div className="panel-header mb-2">
        <div className="mapped-info">
          <span className="mapped-label">Mapped variant:</span>
          <div className="mapped-count">
            <span className="count-current">{mappedCount}</span>
            <span className="count-total">/{totalCount}</span>
          </div>
        </div>
        <FilterPopover
          ContentComponent={({togglePopover}) => (
            <VariantFilterPopover
              onApply={onFilterClick}
              togglePopover={togglePopover}
              variantFilter={variantFilter}
              selectedFilters={selectedFilters}
            />
          )}
          placement="bottom"
          trigger="click"
          popoverOffsetY={8}
        />
      </div>

      <div className="variants-list">
        {variants.map((variant, index) => (
          <VariantItem
            key={index}
            variant={variant}
            isSelected={selectedVariantId === variant._id}
            onClick={() => onVariantSelect(variant)}
          />
        ))}
      </div>
    </div>
  );
};

export default VariantMappingPanel;
